export default "__VITE_ASSET__0a3d698b__"